/* 🤖 this file was generated by svg-to-ts */
export const matIconDriveFileMove: {
  name: 'drive-file-move';
  data: string;
} = {
  name: 'drive-file-move',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l1.41 1.41.59.59H20v10zm-7.84-6H8v2h4.16l-1.59 1.59L11.99 17 16 13.01 11.99 9l-1.41 1.41L12.16 12z"/></svg>`
};
